/** タブを含まない */
export const excludeTab = /^(?!.*\t).*$/s;

/** タブと改行を含まない */
export const excludeTabAndNewline = /^(?!.*(\t|\n)).*$/s;

/** 半角数字 */
export const halfWidthNumber = /^\d*$/;

/** 半角英数字 + メール利用を想定した記号@_.- */
export const halfWidthWithMailSymbol = /^[a-zA-Z0-9@_.-]*$/;

/**
 * 店舗/企業名（カナ）
 * 全角英数字一部記号
 */
// eslint-disable-next-line no-irregular-whitespace
export const nameKanaRegex = /^[\p{sc=Katakana}Ａ-Ｚａ-ｚ０-９（）「」／．＿＋＼ー－‐　]*$/u;

/**
 * 店舗/企業（ローマ字）
 * 半角英数字記号（"と,除く）
 */
export const nameRomajiRegex = /^[ !#-+--~]*$/;

/** 全角文字(制御文字を含まない) */
// eslint-disable-next-line no-control-regex
export const fullWidthCharacter = /^[^\x00-\x1F\x7Fｦ-ﾟ]*$/;

/** 郵便番号(ハイフン有り無し両方可) */
export const postalCode = /^\d{3}-?\d{4}$/;

/** 電話番号
 * 下記３つのパターンを網羅
 *
 * 0含めて市外局番が6桁か5桁、市内局番はなくてその次が4桁
 * 0含めて市外局番、市内局番合わせて6桁か5桁、その次が4桁
 * 090-1234-5678形式の11桁（携帯電話のとき）
 */
// eslint-disable-next-line max-len
export const phoneNumberWithHyphenRequired = /^0\d{4,5}-\d{4}$|^0\d{1}-\d{3,4}-\d{4}$|^0\d{2}-\d{2,3}-\d{4}$|^0\d{3}-\d{1,2}-\d{4}$|^0\d{4}-\d{1}-\d{4}$|^0\d{2}-\d{4}-\d{4}$/;

/** 全銀フォーマット口座名義 */
export const bankAccountHolder = /^[ｱ-ﾝa-zA-Z0-9ﾞﾟ .<(+\\*);%\->?:#@=&_/]*$/;

/** ログインID
 *
 * 半角英数
 * 記号は+@-_.のみ許可(任意)
 * 半角英字、半角数字は必須
*/
// eslint-disable-next-line no-useless-escape
export const logindId = /^(?=.*[a-zA-Z0-9])[\w+@.\-]*$/;

/** 半角英数字 */
export const halfWidthAlphanumeric = /^[0-9a-zA-Z]*$/;

/**
 * パスワード
 * - 半角英数字（英字の大文字、小文字、数字は各々1つ以上含む））
 * - 記号は!"#$%&'()*+,-./:;<=>?@[¥]^_`{|}~のみ許可(任意)
 */
export const password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[¥\]^_`{|}~]*$/;

/**
 * パスワード（大文字小文字区別なし）
 * - 半角英数字（英字、数字は各々1つ以上含む））
 * - 記号は!"#$%&'()*+,-./:;<=>?@[¥]^_`{|}~のみ許可(任意)
 */
export const passwordAnycase = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[¥\]^_`{|}~]*$/;

/** 生年月日(yyyy/mm/dd) */
export const birthdayWithSlash = /^((19|20)\d{2}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01]))*$/;

/** 生年月日(yyyy-mm-dd) */
export const birthdayWithHyphen = /^((19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]))*$/;

/** 全角文字のみ(fullWidthCharacterは半角数字とかがOKなので) */
export const fullWidthCharacterOnly = /^(^[^ -~｡-ﾟ]+)?$/;

/** 電話番号 10桁以上11桁以下 */
export const phoneDigits = /^\d{10,11}$/;

/** メールアドレス 6桁以上100桁以下 */
export const emailDigits = /^.{6,100}$/;
